(() => {
  const SELECTORS = {
    wrapper: '.vipOptin',
    vipBtn: '.vipOptin__card--vip',
    guestBtn: '.vipOptin__card--guest',
  };

  function qs(root, sel) { return (root || document).querySelector(sel); }
  function qsa(root, sel) { return Array.from((root || document).querySelectorAll(sel)); }

  function getWrapper() {
    return qs(document, SELECTORS.wrapper);
  }

  function getAppCheckbox(wrapper) {
    if (!wrapper) return null;

    // Comes from vip-optin-drawer.liquid: data-app-selector="..."
    const selector = wrapper.getAttribute('data-app-selector');
    if (!selector) return null;

    // App checkbox is inside the cart drawer DOM (not inside wrapper)
    return qs(document, selector);
  }

  function setPressed(wrapper, vipOn) {
    const vip = qs(wrapper, SELECTORS.vipBtn);
    const guest = qs(wrapper, SELECTORS.guestBtn);
    if (!vip || !guest) return;

    vip.setAttribute('aria-pressed', vipOn ? 'true' : 'false');
    guest.setAttribute('aria-pressed', vipOn ? 'false' : 'true');
  }

  function setAppCheckbox(checkbox, checked) {
    if (!checkbox) return false;

    // If it’s already correct, still dispatch a change so the app recalculates
    checkbox.checked = !!checked;

    // Dispatch BOTH change + input to satisfy different apps
    checkbox.dispatchEvent(new Event('input', { bubbles: true }));
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function syncFromApp(wrapper, checkbox) {
    if (!wrapper || !checkbox) return;
    setPressed(wrapper, !!checkbox.checked);
  }

  function bindOnce(wrapper) {
    if (!wrapper || wrapper.dataset.vipBound === '1') return;
    wrapper.dataset.vipBound = '1';

    // Event delegation so it still works if inner nodes change
    wrapper.addEventListener('click', (e) => {
      const vipBtn = e.target.closest(SELECTORS.vipBtn);
      const guestBtn = e.target.closest(SELECTORS.guestBtn);
      if (!vipBtn && !guestBtn) return;

      e.preventDefault();

      const checkbox = getAppCheckbox(wrapper);
      if (!checkbox) {
        // If app not ready yet, mark visually but try again shortly
        setPressed(wrapper, !!vipBtn);
        setTimeout(() => {
          const cbLater = getAppCheckbox(wrapper);
          if (cbLater) setAppCheckbox(cbLater, !!vipBtn);
        }, 250);
        return;
      }

      const turnedOn = !!vipBtn;
      setPressed(wrapper, turnedOn);
      setAppCheckbox(checkbox, turnedOn);
    });
  }

  function init() {
    const wrapper = getWrapper();
    if (!wrapper) return;

    bindOnce(wrapper);

    // Wait for app checkbox to exist, then sync + listen
    const tryAttach = () => {
      const checkbox = getAppCheckbox(wrapper);
      if (!checkbox) return false;

      // Avoid attaching duplicate listeners if the app re-renders
      if (checkbox.dataset.vipLinked === '1') {
        syncFromApp(wrapper, checkbox);
        return true;
      }
      checkbox.dataset.vipLinked = '1';

      syncFromApp(wrapper, checkbox);

      checkbox.addEventListener('change', () => syncFromApp(wrapper, checkbox));
      checkbox.addEventListener('input', () => syncFromApp(wrapper, checkbox));

      return true;
    };

    // Retry for a short window (apps load async)
    let attempts = 0;
    const timer = setInterval(() => {
      attempts += 1;
      if (tryAttach() || attempts > 40) clearInterval(timer);
    }, 150);
  }

  // Re-init whenever the cart drawer updates (ajax render)
  function observeCart() {
    const drawer = document.querySelector('#cart-drawer') || document.body;
    const mo = new MutationObserver(() => {
      // Reset bound flag so new markup gets wired up
      const w = getWrapper();
      if (w) w.dataset.vipBound = '0';
      init();
    });
    mo.observe(drawer, { childList: true, subtree: true });
  }

  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      observeCart();
    });
  } else {
    init();
    observeCart();
  }
})();

(function () {
  // ✅ Put your VIP variant id here (from /products/vip-membership.js)
  const VIP_VARIANT_ID = 44031588040806;

  

  let isFixing = false;

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }

  async function changeLine(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity })
    });
  }

  async function enforceVipMaxOne() {
    if (isFixing) return;
    isFixing = true;

    try {
      const cart = await fetchCart();
      const vipLines = (cart.items || []).filter(
        (i) => Number(i.variant_id) === Number(VIP_VARIANT_ID)
      );

      if (!vipLines.length) return;

      // Keep first VIP line at qty 1, remove any extras.
      for (let idx = 0; idx < vipLines.length; idx++) {
        const line = vipLines[idx];
        if (idx === 0) {
          if (line.quantity > 1) await changeLine(line.key, 1);
        } else {
          await changeLine(line.key, 0);
        }
      }
    } catch (e) {
      console.warn('[VIP max=1] failed:', e);
    } finally {
      isFixing = false;
    }
  }

  // Run immediately on load
  enforceVipMaxOne();

  // Run after common cart interactions (covers most themes + many apps)
  document.addEventListener(
    'click',
    () => {
      setTimeout(enforceVipMaxOne, 250);
      setTimeout(enforceVipMaxOne, 900);
    },
    true
  );

  // If your theme/app dispatches these, hook them too
  document.addEventListener('cart:updated', () => setTimeout(enforceVipMaxOne, 150));
  document.addEventListener('cart:refresh', () => setTimeout(enforceVipMaxOne, 150));

  // If the 3rd party widget uses ajax without clicks, this catches most of those too:
  const _fetch = window.fetch;
  window.fetch = function () {
    return _fetch.apply(this, arguments).then((res) => {
      try {
        const url = arguments[0] && arguments[0].toString ? arguments[0].toString() : '';
        if (/\/cart\/(add|change|update|clear)\.js/.test(url)) {
          setTimeout(enforceVipMaxOne, 250);
          setTimeout(enforceVipMaxOne, 900);
        }
      } catch (e) {}
      return res;
    });
  };
})();

